import { useGetDataSelectSalesTabQuery } from "@saleor/graphql";
import { mapNodeToChoiceWithCode } from "@saleor/utils/maps";
import { useMemo } from "react";

function useSales(saleOrgCode) {
  const { data: dataSalesTab } = useGetDataSelectSalesTabQuery({
    // displayLoader: true,
    variables: {
      saleOrg: saleOrgCode
    },
    skip: !saleOrgCode
  });

  const saleOrganizationChoices = useMemo(
    () =>
      mapNodeToChoiceWithCode(
        dataSalesTab?.salesOrganizations,
        null,
        item => item.shortName
      ),
    [dataSalesTab]
  );

  const distributionChannelChoices = useMemo(
    () => mapNodeToChoiceWithCode(dataSalesTab?.distributionChannelsDomestic),
    [dataSalesTab]
  );

  const saleOfficeChoices = useMemo(
    () => mapNodeToChoiceWithCode(dataSalesTab?.salesOffices),
    [dataSalesTab]
  );

  const saleGroupChoices = useMemo(
    () => mapNodeToChoiceWithCode(dataSalesTab?.salesGroups),
    [dataSalesTab]
  );

  const divisionChoices = useMemo(
    () => mapNodeToChoiceWithCode(dataSalesTab?.scgDivisions),
    [dataSalesTab]
  );

  return [
    saleGroupChoices,
    divisionChoices,
    saleOfficeChoices,
    distributionChannelChoices,
    saleOrganizationChoices
  ];
}

export default useSales;
